import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {Dialog, DialogContent, DialogTitle} from '@material-ui/core'
import {BuilderCardField, BuilderCardStore, useBuilderCardStore, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './WhyNoPublishPopoverPanel.css'

/// region Store

export class WhyNoPublishPopoverPanelStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: {cardStore: BuilderCardStore} & Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable foo = false

  @computed get bar() { return null }

  @action verb = () => {}
}

export const WhyNoPublishPopoverPanelStoreContext = React.createContext<WhyNoPublishPopoverPanelStore>(null)
export const useWhyNoPublishPopoverPanelStore = () => React.useContext(WhyNoPublishPopoverPanelStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const WhyNoPublishPopoverPanel = observer<MyProps>(function WhyNoPublishPopoverPanel({className, ...props}) {
  const cardStore = useBuilderCardStore(),
    obsProps = useAsObservableSource({...props, cardStore}),
    store = useVipLocalStore((stores) => new WhyNoPublishPopoverPanelStore(stores, obsProps)),
    {props: {cardStore: {canPublish, publishValidationFailures}}} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <WhyNoPublishPopoverPanelStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
          <div className={css.title}>
            Cannot Publish to C8
          </div>
          <div className={css.failures}>
            {_.keys(publishValidationFailures).map((f, i) => <ValidationFailure key={i} field={f} />)}
          </div>
      </div>
    </WhyNoPublishPopoverPanelStoreContext.Provider>)
})

export const ValidationFailure = observer<{field: string}>(function ValidationFailure(props) {
    const {catalog, catalog: {_fieldByName}, data} = useBuilderCardStore(),
      field = _fieldByName[props.field]

    return (<div className={css.failure}>
      <div className={css.value}>
        {field ? <BuilderCardField f={field} isPopover /> : <span>Unknown field: '{props.field}'</span>}
      </div>
    </div>)
})
/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/WhyNoPublishPopoverPanel.tsx